import Phaser from 'phaser';
import { GAME_WIDTH, IS_PORTRAIT_LAYOUT, UI_CENTER_X } from '../core/Config';
import { GameSettings } from '../core/GameSettings';

export class ActionPanel {
  private readonly elements: Array<Phaser.GameObjects.Rectangle | Phaser.GameObjects.Text>;
  private readonly text: Phaser.GameObjects.Text;
  private readonly panelY: number;
  private hideTimer?: Phaser.Time.TimerEvent;

  constructor(private readonly scene: Phaser.Scene) {
    const mobile = IS_PORTRAIT_LAYOUT;
    const panelWidth = mobile ? GAME_WIDTH - 52 : Math.min(GAME_WIDTH - 120, 980);
    const panelHeight = mobile ? 190 : 120;
    this.panelY = mobile ? 158 : 92;

    const outer = scene.add
      .rectangle(UI_CENTER_X, this.panelY, panelWidth, panelHeight, 0x172019, 0.98)
      .setStrokeStyle(mobile ? 5 : 4, 0xe8c768)
      .setScrollFactor(0)
      .setDepth(10020)
      .setVisible(false);
    const inner = scene.add
      .rectangle(UI_CENTER_X, this.panelY, panelWidth - 30, panelHeight - 30, 0x0c120f, 0.98)
      .setStrokeStyle(2, 0x8ebc98, 0.68)
      .setScrollFactor(0)
      .setDepth(10021)
      .setVisible(false);
    const title = scene.add
      .text(UI_CENTER_X - panelWidth / 2 + (mobile ? 34 : 38), this.panelY - panelHeight / 2 + (mobile ? 22 : 14), '작업 결과', {
        fontSize: mobile ? '29px' : '18px',
        color: '#ffe391',
        fontStyle: 'bold',
      })
      .setScrollFactor(0)
      .setDepth(10022)
      .setVisible(false);
    const badge = scene.add
      .text(UI_CENTER_X + panelWidth / 2 - (mobile ? 170 : 150), this.panelY - panelHeight / 2 + (mobile ? 20 : 14), '완료', {
        fontSize: mobile ? '25px' : '16px',
        color: '#c9eccd',
        backgroundColor: '#294730dd',
        padding: { x: 10, y: 5 },
      })
      .setScrollFactor(0)
      .setDepth(10022)
      .setVisible(false);
    const icon = scene.add
      .text(UI_CENTER_X - panelWidth / 2 + (mobile ? 34 : 20), this.panelY - (mobile ? 18 : 22), '>', {
        fontSize: mobile ? '36px' : '24px',
        color: '#ffe391',
        fontStyle: 'bold',
      })
      .setScrollFactor(0)
      .setDepth(10022)
      .setVisible(false);
    this.text = scene.add
      .text(UI_CENTER_X - panelWidth / 2 + (mobile ? 78 : 48), this.panelY - (mobile ? 12 : 22), '', {
        fontSize: mobile ? '28px' : '22px',
        color: '#eff8ed',
        lineSpacing: mobile ? 8 : 6,
        wordWrap: { width: panelWidth - (mobile ? 120 : 92) },
      })
      .setScrollFactor(0)
      .setDepth(10022)
      .setVisible(false);
    this.elements = [outer, inner, title, badge, icon, this.text];
  }

  flash(lines: string[]) {
    this.hideTimer?.remove(false);
    this.text.setText(lines.slice(0, 3).map((line) => `- ${line}`).join('\n'));
    this.elements.forEach((item) => item.setVisible(true));

    if (GameSettings.get('uiMotion')) {
      this.elements.forEach((target) => {
        this.scene.tweens.killTweensOf(target);
        target.setAlpha(0);
        target.setY(target.y - 24);
      });
      this.scene.tweens.add({ targets: this.elements, alpha: 1, y: '+=24', duration: 190, ease: 'quad.out' });
    }

    this.hideTimer = this.scene.time.delayedCall(3000, () => {
      if (GameSettings.get('uiMotion')) {
        this.scene.tweens.add({
          targets: this.elements,
          alpha: 0,
          y: '-=12',
          duration: 180,
          ease: 'quad.in',
          onComplete: () => this.elements.forEach((item) => item.setVisible(false)),
        });
      } else {
        this.elements.forEach((item) => item.setVisible(false));
      }
    });
  }
}
